/**
 * Icon-Namen, die im selbst gehosteten Material-Symbols-Subset
 * (`public/fonts/MaterialSymbolsRounded.woff2`) enthalten sind — einzige Quelle
 * fuer den Umfang des Subsets, analog zu `designTokens.ts` fuer Farben und Radien.
 *
 * Warum als Code und nicht als Textdatei: Der Guard-Test
 * `__tests__/materialSymbolsSubset.test.ts` vergleicht diese Liste gegen alle im
 * Code verwendeten Icon-Namen und laeuft damit auch in der CI. Frueher lag die
 * Liste nur im untracked `design-system-seed/` und der Test waere dort still
 * uebersprungen worden.
 *
 * NEUES ICON HINZUFUEGEN:
 *  1. Namen hier einsortieren — die Liste MUSS alphabetisch sortiert bleiben,
 *     sonst liefert Google eine HTML-Fehlerseite statt einer Schrift.
 *  2. Subset neu ziehen:
 *     https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&icon_names=<komma-liste>&display=block
 *  3. woff2 aus der `src:`-URL der Antwort herunterladen und nach
 *     `public/fonts/MaterialSymbolsRounded.woff2` legen.
 *
 * Fehlt ein Icon im Subset, rendert der Browser die Ligatur als Klartext — im
 * Hauptmenue stand deshalb "smart_toy" statt eines Icons.
 */
export const MATERIAL_SYMBOLS_SUBSET: readonly string[] = [
    'add',
    'alarm',
    'analytics',
    'apps',
    'arrow_back',
    'arrow_forward',
    'article',
    'auto_awesome',
    'badge',
    'bar_chart',
    'bolt',
    'bookmark',
    'bookmark_add',
    'calendar_month',
    'campaign',
    'cancel',
    'card_membership',
    'chat',
    'check',
    'check_box',
    'check_circle',
    'checklist',
    'chevron_right',
    'close',
    'cloud_upload',
    'code',
    'collections_bookmark',
    'comment',
    'content_copy',
    'create_new_folder',
    'credit_card',
    'dashboard',
    'delete',
    'description',
    'diamond',
    'done_all',
    'download',
    'drag_indicator',
    'edit',
    'emoji_events',
    'error',
    'euro',
    'event',
    'expand_more',
    'explore',
    'fact_check',
    'filter_alt',
    'flag',
    'folder',
    'folder_open',
    'format_list_bulleted',
    'forum',
    'fullscreen',
    'grade',
    'grid_view',
    'group_add',
    'groups',
    'help',
    'history',
    'hourglass_top',
    'image',
    'inbox',
    'info',
    'insights',
    'key',
    'label',
    'language',
    'layers',
    'leaderboard',
    'lightbulb',
    'link',
    'list',
    'local_fire_department',
    'lock',
    'logout',
    'mail',
    'manage_accounts',
    'menu',
    'menu_book',
    'military_tech',
    'monitoring',
    'more_horiz',
    'more_vert',
    'navigate_before',
    'navigate_next',
    'new_releases',
    'note_add',
    'note_alt',
    'notifications',
    'open_in_new',
    'palette',
    'pause',
    'payment',
    'pending',
    'person',
    'person_add',
    'picture_as_pdf',
    'play_arrow',
    'print',
    'psychology',
    'query_stats',
    'quiz',
    'rate_review',
    'receipt_long',
    'refresh',
    'remove',
    'replay',
    'route',
    'save',
    'schedule',
    'school',
    'science',
    'search',
    'search_off',
    'sell',
    'settings',
    'shopping_bag',
    'shopping_cart',
    'smart_display',
    'smart_toy',
    'sort',
    'speed',
    'star',
    'stars',
    'storefront',
    'subject',
    'sync',
    'task_alt',
    'thumb_up',
    'timer',
    'today',
    'translate',
    'trending_up',
    'tune',
    'update',
    'upload',
    'verified',
    'verified_user',
    'view_list',
    'visibility',
    'vpn_key',
    'warning',
    'web',
    'whatshot',
    'workspace_premium',
] as const;

export default MATERIAL_SYMBOLS_SUBSET;
